﻿import { useMutation } from 'react-query';

import NoteService from 'services/note.service';

export function useAddNote(options) {
  return useMutation((payload) => NoteService.add(payload), options);
}
